import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 2rem;

  button{
    margin-right: 8px;
  }

  button{
    margin-left: 8px;
  }
`;

export const Container = styled.div`
  margin: 0 auto 1rem;
  overflow-y: hidden;
  h1 {
    margin-bottom: 24px;

    strong {
      color: red;
      display: flex;
      flex-direction: column;
      font-size: 35%;
      opacity: 0.75;
    }
  }


`;

export const Table = styled.table`
    border-spacing: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray.oslo};
    border-top: 1px solid ${({ theme }) => theme.colors.gray.oslo};
    min-width: 500px;
    display: table;
    width: 100%;

    tbody tr:nth-child(odd) {
    background-color: #FFF;
    }

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th{
      font-weight: bold;
      vertical-align: middle;
    }

    th, td {
      border-bottom: 1px solid ${({ theme }) => theme.colors.gray.oslo};
      border-right: 1px solid ${({ theme }) => theme.colors.gray.oslo};
      font-size: 0.85rem;
      margin: 0;
      padding:  0.5rem 0.75rem;
      white-space: nowrap;
      :last-child {
        border-right: 0;
      }
    }

    /* td:nth-child(2), td:nth-child(3){
      text-shadow: 0 0 10px rgba(0,0,0,0.5);
      color: transparent;
      a{
        color: transparent;
        text-shadow: 0 0 10px rgba(0,0,0,0.5);
      }
    } */
`;

export const ResultTableData = styled.td`
  background: ${({ isSuccess, isWarning }) => (isSuccess ? '#27ae6070'
    : isWarning ? '#FAB00570' : '#eb575770')};
  color: ${({ theme, isSuccess }) => (isSuccess ? theme.colors.success : theme.colors.error)};
  font-weight: 600;
  border-left: 0.25rem solid ${({ theme, isSuccess }) => (isSuccess
    ? theme.colors.success : theme.colors.error)} ;
`;
